import React from 'react'
// layers
import ResourcesListAPI from 'containers/Activities/layers/API/ResourcesList'
import ResourcesListBL from 'containers/Activities/layers/BL/ResourcesList'
// components
import ResourcesList from 'components/Modals/PlanItems/components/ResourcesList/index'

const ResourcesListContainer = props => (
  <ResourcesListAPI {...props}>
    <ResourcesListBL>
      <ResourcesList />
    </ResourcesListBL>
  </ResourcesListAPI>
)

export default ResourcesListContainer
